/**
 * "Export CSV" button shared by the earnings + payouts surfaces. The label
 * is passed in already resolved through `useI18n()`. Disabled when there's
 * nothing to export so the affordance never dead-ends into an empty file.
 */
export function ExportCsvButton({
  label,
  onClick,
  disabled,
}: {
  readonly label: string;
  readonly onClick: () => void;
  readonly disabled?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      style={{
        padding: '0.375em 0.875em',
        minHeight: 'var(--touch-target)',
        borderRadius: 'var(--radius-pill)',
        border: '1px solid var(--color-border-strong)',
        background: 'var(--color-surface)',
        color: disabled ? 'var(--color-on-surface-muted)' : 'var(--color-on-surface)',
        fontSize: 'var(--text-meta)',
        fontWeight: 500,
        lineHeight: 1.3,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </button>
  );
}
